import {getKeyId} from "@/api/index.api";
import {getAppUserInfo} from "@/api/tianyi/tianyi.api";

const state = {
    user: {},
    publicKey: {},
    token:{}
};
const getters = {
    user(state) {
        return state.user;
    },
    publicKey(state) {
        return state.publicKey;
    },
    token(state) {
        return state.token;
    },
};
const mutations = {
    SET_USER_INFO: (state, data) => {
        state.user = data;
    },
    SET_PUBLIC_KEY: (state, data) => {
        state.publicKey = data;
    },
    SET_TOKEN: (state, data) => {
        state.token = data;
    },
};
const actions = {
    setUserInfo(context, userInfo) {
        context.commit('SET_USER_INFO', userInfo);
    },
    getUploadDetails({commit, state}, token) {
        return new Promise(resolve => {
            getAppUserInfo(token).then((resp) => {
                if (resp.code === 0) {
                    commit("SET_USER_INFO", resp.data);
                }
                resolve(resp);
            })
        });
    },
    getPublicKey({commit, state}) {
        return new Promise(resolve => {
            getKeyId().then((resp) => {
                commit("SET_PUBLIC_KEY", resp.data);
                if (resp.code === 0) {
                    resolve(state.publicKey);
                }
            })
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
